import { getData, postRequest } from "./api";
import { CreateUser, USER_API } from "./user.api.types";

const createUser = (user: CreateUser) => {
  return postRequest(USER_API.createUser, user);
};

const getUser = (userEmail: string) => {
  return getData(USER_API.getUser(userEmail));
};

const getUsers = () => {
  return getData(USER_API.getUsers);
};
export { createUser, getUser, getUsers };
